import { GetterTree } from 'vuex'

import { DashboardStateTypes } from './index'
import { RootState } from '@/store/store.type'
import { DASHBOARD_STORE } from '@/store/constants'

export const getters: GetterTree<DashboardStateTypes, RootState> = {
  [DASHBOARD_STORE.GETTERS.LATEST_ANALYTIC_DATE]: (state: DashboardStateTypes): any => state.latest_analytics_date,
}
